import { render, staticRenderFns } from "./bcpay.vue?vue&type=template&id=218133fe&scoped=true"
import script from "./bcpay.vue?vue&type=script&lang=js"
export * from "./bcpay.vue?vue&type=script&lang=js"
import style0 from "./bcpay.vue?vue&type=style&index=0&id=218133fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218133fe",
  null
  
)

export default component.exports